<template>
  <div class="c_table_wrap">
    삭제 아이템 라이트 레이아웃
    <div>
      <button @click="$router.back()">목록</button>
      <button @click="$router.back()">저장</button>
    </div>
  </div>
</template>

<script>
export default {
  name: "ItemWriteDeleteItemLayout",
  mixins: [],
  components: {
  },
  inject: [],
  provide() {
    return{

    }
  },
  props: {
  },
  data() {
    return{

    }
  },
  beforeRouterEnter() {},
  created() {
  },
  mounted() {

  },
  beforeDestroy() {
  },
  destroyed() {},
  computed: {
  },
  methods:{

  },
  watch: {

  },
}
</script>

<style scoped>

</style>